//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  mounted () {
    this.tl = gsap.timeline({
      onComplete: (...args) => {
        this.$emit('complete', ...args)
      }
    })

    this.tl.set(['#wall', '#floor', '#button'], { opacity: 0 })
    this.tl.set(['#hand'], { x: '100%' })
    this.tl.set(['#device'], { transformOrigin: '50% 50%'})
    // this.tl.set(['#tablet'], { opacity: 0 })

    this.tl
      .from(['#tablet'], { opacity: 0, duration: 0.5 })
      .to(['#hand'], { x: 330, duration: 1 })
      .to(['#hand', '#slider'], { x: '-=415px' })
      .to(['#button'], { opacity: 1, duration: 0.3 })
      .to(['#hand'], { x: 320, y: '+100' })
      .to(['#hand'], { x: 170, y: 280, delay: 0.3 })
      .to(['#button-bg'], { fill: '#000', duration: 0.15 })
      .to(['#button-text path'], { fill: '#fff', duration: 0.15 }, '<')
      .to(['#hand'], { y: 600, duration: 0.3 }, '<0.2')
      .to(['#device'], { scale: 0, duration: 1.5 })
      .to(['#wall'], { opacity: 1, duration: 1 }, '<')
      .from(['#wall-left'], { x: '-=200', ease: 'expo.out', duration: 1 }, '<')
      .from(['#wall-right'], { x: '+=200', ease: 'expo.out', duration: 1 }, '<')
      .from(['#floor'], { y: '+=300', opacity: 0, ease: 'expo.out', duration: 1 }, '<')
      // .to(['#floor'], { y: '+=100', opacity: 0, duration: 0.1, delay: 3 })
      // .to(['#wall-left'], { x: '-=100', opacity: 0, duration: 0.1 }, '<')
      // .to(['#wall-right'], { x: '+=100', opacity: 0, duration: 0.1 }, '<')
      // .to(['#tablet'], { y: '-=100', opacity: 0, duration: 0.1 }, '<')
  },
  beforeDestroy () {
    this.tl.kill()
  }
}
